import { FiClock, FiMapPin, FiShield, FiUser } from 'react-icons/fi'
import { useFadeUp } from '../hooks/usefadeup'
import './Home.css'

export default function Home() {
  const heroRef = useFadeUp<HTMLElement>()

  return (
    <section className="hero hero--inspired" id="inicio" ref={heroRef}>
      <div className="hero__bg" />
      <div className="hero__glow" />
      <div className="hero__grain" />

      <div className="hero__wrap">
        <div className="hero__content" data-fade data-fade-delay="0">
          <h1 className="hero__title" data-fade data-fade-delay="120">
            Proteção inteligente
            <span>para cada etapa</span>
            da sua vida
          </h1>

          <p className="hero__sub" data-fade data-fade-delay="240">
            Soluções de seguros feitas à medida para famílias, empresas e patrimónios em Moçambique.
            Conte com a Makhowo Seguros em cada etapa da sua vida.
          </p>

          <div className="hero__actions" data-fade data-fade-delay="360">
            <a href="/cotacoes" className="btn-primary">Pedir Cotação</a>
            <a href="#servicos" className="btn-outline">Nossos Serviços</a>
          </div>

        </div>
      </div>

      <div className="hero__feature-container" data-fade data-fade-delay="420">
        <div className="hero__feature-bar">
          <div>
            <FiShield aria-hidden="true" />
            <span>Proteção Completa</span>
          </div>
          <div>
            <FiUser aria-hidden="true" />
            <span>Atendimento Personalizado</span>
          </div>
          <div>
            <FiClock aria-hidden="true" />
            <span>Resposta Rápida</span>
          </div>
          <div>
            <FiMapPin aria-hidden="true" />
            <span>Cobertura Nacional</span>
          </div>
        </div>
      </div>
    </section>
  )
}